/*eslint-disable */
import React from 'react';
import SvgIcon from './SvgIcon';

interface Props {
  width?: number;
  height?: number;
  alt?: string;
  color1?: string;
  color2?: string;
}

const DownloadIcon: React.FC<Props> = (props: Props) => {
  const { width = 48, height = 38, alt = 'Download', color1 = '#6BBB50', color2 = '#1DA281' } = props;

  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" version="1.1" width={width} height={height} viewBox="0 0 48 38">
      <title>{alt}</title>
      <defs>
        <linearGradient x1="0%" y1="50%" x2="100%" y2="50%" id="linearGradient-1">
          <stop stopColor={color1} offset="0%" />
          <stop stopColor={color2} offset="100%" />
        </linearGradient>
      </defs>
      <g id="Uploader-2019-08" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Artboard">
          <g id="Group-7" transform="translate(1.000000, 1.000000)">
            <g id="noun_Camera_1751215" stroke="#626262" strokeWidth="2">
              <g id="Group">
                <path
                  d="M10.9103982,1.65927092 L9.21325233,5.53846154 L4.15384615,5.53846154 C1.85974027,5.53846154 0,7.39820181 0,9.69230769 L0,26.3076923 C0,28.6017981 1.85974027,30.4615385 4.15384615,30.4615385 L31.8461538,30.4615385 C34.1402597,30.4615385 36,28.6017981 36,26.3076923 L36,9.69230769 C36,7.39820181 34.1402597,5.53846154 31.8461538,5.53846154 L26.7867476,5.53846154 L25.0896017,1.65927092 C24.6486171,0.651306018 23.65276,0 22.5525507,0 L13.4474493,0 C12.3472399,0 11.3513829,0.651306018 10.9103982,1.65927092 Z M18,24.9230769 C14.1764903,24.9230769 11.0769231,21.8235097 11.0769231,18 C11.0769231,14.1764903 14.1764903,11.0769231 18,11.0769231 C21.8235097,11.0769231 24.9230769,14.1764903 24.9230769,18 C24.9230769,21.8235097 21.8235097,24.9230769 18,24.9230769 Z"
                  id="Shape"
                />
              </g>
            </g>
            <circle id="Oval" fill="url(#linearGradient-1)" cx="36.5" cy="26.5" r="10.5" />
            <text
              id="+"
              fontFamily="HelveticaNeue-Bold, Helvetica Neue"
              fontSize="17"
              fontWeight="bold"
              letterSpacing="-0.400000006"
              fill="#FFFFFF"
            >
              <tspan x="32" y="32">
                +
              </tspan>
            </text>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export default DownloadIcon;
